module.exports = __webpack_public_path__ + "static/media/Top_Logos_rnd.bb401e17.png";